$(document).ready(function() {
  const el = document.querySelector('.js-counter');

  $('.js-counter').counterUp({
      delay: 10,
      time: 1500,
      offset: 90
  });
});
